// src/constants/negocios.js
export const TIPOS_IMOVEL = [
  'Casa',
  'Apartamento',
  'Apartamento na planta',
  'Kitnet',
  'Terreno / Área',
  'Sala comercial',
  'Ponto comercial',
  'Galpão / Barracão',
  'Empreendimentos',
  'Chácara',
  'Fazenda',
];

export const OBJETIVOS_BUSCA = [
  'Primeiro imóvel',
  'Upgrade (imóvel maior/melhor)',
  'Trocar por imóvel menor',
  'Investimento',
  'Comprar para renda (aluguel)',
  'Buscar terreno',
  'Buscar casa em condomínio',
  'Imóvel comercial',
  'Permuta (usar imóvel atual)',
  'Oportunidade abaixo do valor',
  'Chácara',
  'Fazenda / Grandes negócios',
];
